<template>
	<div class="generic-popup-container" v-if="openPopup">
		<div class="generic-popup-background">
			<component :is="componentToRender" @closeGenericPopup="closeGenericPopup"/>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';

export default {
	name: 'GenericPopup',
	data() {
		return {
			openPopup: false,
			componentToRender: null,
			closeResolver: null,
		};
	},
	methods: {
		openGenericPopup(component, resolve) {
			this.componentToRender = component;
			this.openPopup = true;
			this.closeResolver = resolve;
		},
		closeGenericPopup(result) {
			this.openPopup = false;
			if (this.closeResolver) {
				this.closeResolver(result);
				this.closeResolver = null;
			}
			this.componentToRender = null;
		}
	},
	created() {
		if (!Vue.prototype.$genericPopup) {
			const instance = this;

			Vue.prototype.$genericPopup = {
				open(component) {
					return new Promise((resolve) => {
						instance.openGenericPopup(component, resolve);
					});
				},
				close(result) {
					instance.closeGenericPopup(result);
				}
			};
		}
	},
};
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.generic-popup-container {
	width: 100%;
	height: calc(100% + 65px);
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
	top: -65px;
	z-index: 102;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	.generic-popup-background {
		background: #F5F5F5;
		width: fit-content;
		height: fit-content;
		padding: 20px;
		position: relative;
		z-index: 103;
	}
}
</style>
